module.exports = __webpack_public_path__ + "assets/images/photos/struktur_organisasi_ppid.jpg";